import { AlertCard, Button, Divider } from "@caprikorn/dynamo-ui";
import type { FC } from "react";
import { Controller } from "react-hook-form";
import { useLocation } from "react-router-dom";

import {
  ADVANCED_REQUESTS,
  STANDARD_REQUESTS,
} from "@services/apiEcms/apiEcms.constants";
import { isSiteRoute } from "@utils/perimeterRoute.utils";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./ActionTypeForm.module.css";
import type { ActionTypeFormProps } from "./ActionTypeForm.types";

export const ActionTypeForm: FC<ActionTypeFormProps> = ({
  control,
  trigger,
}) => {
  const { t } = useCustomTranslation(["main", "common"]);
  const { pathname } = useLocation();
  const enableChoices = isSiteRoute(pathname);
  const advancedOptionsFormated = ADVANCED_REQUESTS.map((key) => ({
    label: t(`requestDrawer.steps.actionType.options.${key}`),
    value: key,
    isDisabled: !enableChoices,
  }));
  const standardOptionsFormated = STANDARD_REQUESTS.map((key) => ({
    label: t(`requestDrawer.steps.actionType.options.${key}`),
    value: key,
    isDisabled: false,
  }));

  return (
    <div className={classes.container} data-testid="TypeForm-RMFormWrapper">
      <Controller
        control={control}
        name="actionTypeForm.actionType"
        render={({ field, fieldState }) => (
          <>
            <div className={classes.buttons}>
              {advancedOptionsFormated.map((option) => (
                <Button
                  key={option.value}
                  disabled={!enableChoices}
                  onClick={() => {
                    field.onChange(option.value);
                    trigger(field.name);
                  }}
                  variant={
                    field.value === option.value ? "primary" : "secondary"
                  }
                >
                  {option.label}
                </Button>
              ))}
              {!enableChoices && (
                <AlertCard variant="warning">
                  <AlertCard.Description>
                    {t("requestDrawer.steps.actionType.warning")}
                  </AlertCard.Description>
                </AlertCard>
              )}
              <Divider />
              {standardOptionsFormated.map((option) => (
                <Button
                  key={option.value}
                  onClick={() => {
                    field.onChange(option.value);
                    trigger(field.name);
                  }}
                  variant={
                    field.value === option.value ? "primary" : "secondary"
                  }
                >
                  {option.label}
                </Button>
              ))}
            </div>

            {fieldState.error?.message && (
              <AlertCard
                aria-label={t("form.error.required", { ns: "common" })}
                variant="error"
              >
                <AlertCard.Description>
                  {t(fieldState.error.message, { ns: "common" })}
                </AlertCard.Description>
              </AlertCard>
            )}
          </>
        )}
        rules={{ required: "form.error.required" }}
      />
    </div>
  );
};
